import { useEffect, useState } from "react";
import { Check, Share2 } from "lucide-react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const setMeta = (attr, key, value) => {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value || "");
};

/** Per-page title and social preview tags. */
export const useShareMeta = ({ title, description, image }) => {
  useEffect(() => {
    if (!title) return;
    const absolute = image?.startsWith("/") ? `${window.location.origin}${image}` : image;
    document.title = `${title} · Smash Lemonade`;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", absolute);
    setMeta("property", "og:url", window.location.href);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", absolute);
  }, [title, description, image]);
};

/**
 * Copies a link that serves real Open Graph tags to crawlers and then
 * redirects people to this page, so shares unfurl with their own image.
 */
export const ShareButton = ({ kind, slug, title, testId = "share-button" }) => {
  const [copied, setCopied] = useState(false);
  const url = `${BACKEND}/api/share/${kind}/${slug}`;

  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch {
        /* fall through to copy */
      }
    }
    await navigator.clipboard.writeText(url);
    setCopied(true);
    toast.success("Share link copied");
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <button
      type="button"
      onClick={share}
      data-testid={testId}
      className="mono inline-flex items-center gap-2 border border-border px-3 py-2 text-[10px] tracking-widest text-primary transition-colors hover:border-primary"
    >
      {copied ? <Check size={12} /> : <Share2 size={12} />}
      {copied ? "LINK COPIED" : "SHARE"}
    </button>
  );
};
